var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mail_template)?_c('mail-templates-editor',{model:{value:(_vm.mail_template),callback:function ($$v) {_vm.mail_template=$$v},expression:"mail_template"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }